import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DatetimeService } from 'src/app/services';

@Component({
  selector: 'app-date-picker-custom-view-control',
  templateUrl: './date-picker-custom-view-control.component.html',
  styleUrls: ['./date-picker-custom-view-control.component.css']
})
export class DatePickerCustomViewControlComponent implements OnInit {

  @Input() valueDateFrom: any;
  @Input() valueDateTo: any;

  @Input() set inputValue(value: any) {

    if (value) {

      this.setInputDateValueToField(value);

    }else{

      this.form.get('date').setValue(null);
    }
  }

  @Output() changeValue = new EventEmitter();

  form: UntypedFormGroup = this.fb.group({
    date: [null, Validators.required],
  });

  currentDate = new Date();
  minDateFrom = this.datetimeService.convertDateForDatepicker(Date());
  minDateTo = this.datetimeService.convertDateForDatepicker(this.currentDate.setDate(this.currentDate.getDate() + 1));

  constructor(private datetimeService: DatetimeService, private fb: UntypedFormBuilder) { }

  ngOnInit(): void {

    this.form.get('date').valueChanges.subscribe(val => {

      if (val) {

        this.outPutData(val);
      }
    })
  }


  /**
   * 
   * @param value 
   */
  setInputDateValueToField(value: any) {

    this.form.get('date').setValue(this.datetimeService.convertDateForDatepicker(value));
  }


  outPutData(formValue: any) {

    this.changeValue.emit(this.datetimeService.convertDateForDB(formValue));
  }
}
